import { render, staticRenderFns } from "./BlockDetails.vue?vue&type=template&id=cfe5be92&scoped=true"
import script from "./BlockDetails.vue?vue&type=script&lang=js"
export * from "./BlockDetails.vue?vue&type=script&lang=js"
import style0 from "./BlockDetails.vue?vue&type=style&index=0&id=cfe5be92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe5be92",
  null
  
)

export default component.exports